export default __webpack_public_path__ + "static/Design_Series-af5c2394b5b6b062c3ae2f864e6906b8.png";